import React, { Suspense } from 'react'
import type { CodeMirrorEditorProps } from './CodeMirrorEditor'

// CodeMirror + its language packages are only needed by presentations using a Custom
// HTML/CSS block, so keep them out of the main editor bundle until one is rendered
const CodeMirrorEditor = React.lazy(() => import('./CodeMirrorEditor'))

export type CodeEditorProps = CodeMirrorEditorProps

function CodeEditor(props: CodeEditorProps) {
  return (
    <Suspense fallback={null}>
      <CodeMirrorEditor {...props} />
    </Suspense>
  )
}

export default CodeEditor
